<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field v-if="item['@id']"
            v-model="item.number"
            :error-messages="numberErrors"
            :label="$t('global.number')"
            required
            v-on:change="item.number = parseInt(item.number)"
            @input="$v.item.number.$touch()"
            @blur="$v.item.number.$touch()"

          />
          <v-text-field v-else
            :label="$t('global.number')"
            disabled

          />
          
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="materialProductVersionSelectItems"
            v-model="item.materialProductVersion"
            :items="materialProductVersionSelectItems"
            :error-messages="materialProductVersionErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('profile.material.productversion')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.externalLot"
            :error-messages="externalLotErrors"
            :label="$t('profile.material.externallot')"
            required
            @input="$v.item.externalLot.$touch()"
            @blur="$v.item.externalLot.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <InputDate
            v-model="item.dlu"
            :label="$t('profile.material.dlu')"
            :error-messages="dluErrors"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <InputDate
            v-model="item.dateManufacture"
            :label="$t('profile.material.datemanufacture')"
            :error-messages="dateManufactureErrors"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6" v-if="!item['file'] || !this.item['file'].id ">
          <p>Aller sur le site pour generer votre QR code au format svg https://qr-code-generator.org/ avec l'url suivante (remplir toutes les données du formulaire en premier) :
            <span> https://hub.lynxter.fr/material_product_versions/<span v-if="item.materialProductVersion">{{ item.materialProductVersion.uuid }}</span>?lot={{ item.number }}</span>
          </p>
          <p>Exemple d'une url valide :  https://hub.lynxter.fr/material_product_versions/4db5f442-98e4-4bc1-851e-191ad96c8c00?lot=1</p>
          
        </v-col>
          <v-col cols="12" sm="6" md="6" v-if="!item['file'] || !this.item['file'].id">
            <v-file-input
              v-model="item.file"
              :error-messages="fileErrors"
              :label="$t('global.fileinput')"
              required
              show-size
            ></v-file-input>
          </v-col>
        </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
//import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import { maxsizefile } from '../../utils/files';
import InputDate from '../InputDate';

export default {
  name: 'MaterialProductLotForm',
  mixins: [validationMixin],
  components: {
    Loading,
    InputDate
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.materialProductVersionGetSelectItems();
  },
  data() {
    return {
        number: null,
        materialProductVersion: null,
        externalLot: null,
        dlu: null,
        datemanufacture: null,
        file: null,
    };
  },
  computed: {
    isLoading() {
      return (
        this.isLoading_materialProductVersion
       );
    },
    ...mapFields('materialproductversion', {
      materialProductVersionSelectItems: 'selectItems',
      isLoading_materialProductVersion : 'isLoading'
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    numberErrors() {
      const errors = [];
      if (!this.$v.item.number.$dirty) return errors;
      has(this.violations, 'number') && errors.push(this.violations.number);
     // !this.$v.item.number.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    externalLotErrors() {
      const errors = [];
      if (!this.$v.item.externalLot.$dirty) return errors;
      has(this.violations, 'externalLot') && errors.push(this.violations.externalLot);
      return errors;
    },
    dluErrors() {
      const errors = [];
      if (!this.$v.item.dlu.$dirty) return errors;
      has(this.violations, 'dlu') && errors.push(this.violations.dlu);
      return errors;
    },
    dateManufactureErrors() {
      const errors = [];
      if (!this.$v.item.datemanufacture.$dirty) return errors;
      has(this.violations, 'datemanufacture') && errors.push(this.violations.datemanufacture);
      return errors;
    },
    materialProductVersionErrors() {
      const errors = [];
      if (!this.$v.item.materialProductVersion.$dirty) return errors;
      has(this.violations, 'materialProductVersion') && errors.push(this.violations.materialProductVersion);
      return errors;
    },
    fileErrors() {
      const errors = [];
      if (!this.$v.item.file.$dirty) return errors;
      has(this.violations, 'file') && errors.push(this.violations.file);
      !this.$v.item.file.maxsizefile && errors.push(this.$t('global.maxsize'));
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
    ...mapActions({
      materialProductVersionGetSelectItems: 'materialproductversion/fetchSelectItems',
    }),
  },
  validations: {
    item: {
      number: {
      },
      dlu: {
      },
      externalLot: {
      },
      datemanufacture: {
      },
      materialProductVersion: {
      },
      file: {
        maxsizefile : maxsizefile(10),
      },
    }
  }
};
</script>
